
// Copyright (c) 2017 Deere & Company

import {when} from './when';

export const updateWalkMeLanguage = language => {

    const walkMeLanguage = (language === 'EN') ? '' : language;

    when(() => typeof window.WalkMeAPI !== 'undefined' && typeof window.WalkMePlayerAPI !== 'undefined', 1000, 20).then(() => window.WalkMeAPI.changeLanguage(walkMeLanguage)).catch(err => err);

};

export const provideWalkMeLanguage = language => {

    const walkMeLanguage = (language === 'EN') ? '' : language;

    /* eslint-disable camelcase */

    window.walkme_get_language = () => walkMeLanguage;

    /* eslint-enable camelcase */

};




// WEBPACK FOOTER //
// ./src/shared/services/walkme.js